import MapRoutePinSvg from "./MapRoutePinSvg";
import { LineRoutes } from "./MapsList";

const MapPinsForLineSvg = ({
  lineRoutes,
  onRouteClick,
  selectedRouteUuids,
  filteredRouteUuids,
  onContextMenu,
  routePinScale = 1,
}: {
  lineRoutes: LineRoutes;
  onRouteClick: (e: React.MouseEvent, uuid: string) => void;
  selectedRouteUuids: Set<string>;
  filteredRouteUuids: Set<string>;
  onContextMenu?: (e: React.MouseEvent, uuid: string) => void;
  /** Extra scale for each pin and the ring's radius. */
  routePinScale?: number;
}) => {
  const circleRadius = lineRoutes.routes.length * 5 * routePinScale;

  return (
    <g transform="scale(1)">
      {lineRoutes.routes.map((route, i) => {
        const angle = Math.PI / 2 - (Math.PI * 2 * i) / lineRoutes.routes.length;
        const x = Math.cos(angle) * circleRadius;
        const y = Math.sin(angle) * circleRadius;
        return (
          <g
            transform={`translate(${x}, ${y})`}
            key={route.uuid}
            opacity={
              (!selectedRouteUuids.size || selectedRouteUuids.has(route.uuid || "")) &&
              (!filteredRouteUuids.size || !route.uuid || filteredRouteUuids.has(route.uuid || ""))
                ? 1
                : 0.5
            }
          >
            <g transform={`scale(${routePinScale})`}>
              <MapRoutePinSvg
                route={route}
                onClick={(e) => route.uuid && onRouteClick(e, route.uuid)}
                onContextMenu={(e) => route.uuid && onContextMenu?.(e, route.uuid)}
                // Only allow routes that don't have a fully-set start line to be dragged
                dragToMoveEnabled={!route.startLine}
              />
            </g>
          </g>
        );
      })}
    </g>
  );
};

export default MapPinsForLineSvg;
